import { useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { useApi } from "../../../hooks/useApi"
import { TradingCompanyDetail } from "../types"

const useUpdateTradingCompanyMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess: (company: TradingCompanyDetail) => void
  onError: (error: AxiosError) => void
}) => {
  const { scientApi } = useApi()
  return useMutation(scientApi.trading.updateTradingCompany, { onSuccess, onError })
}

export default useUpdateTradingCompanyMutation
